import { DataTableSortOrderType } from "primereact/datatable";
// export const baseUrl: string = "https://localhost:57035/api/";
// export const baseUrl: string = "https://localhost:7149/api/";
//export const baseUrl: string = "https://api-stg.nexustv.jobvritta.com/api/"
//export const baseUrl: string = "https://api.nexustv.jobvritta.com/api/"
export interface IEnvironmentConfig {
  websiteUrl: string;
  baseUrl: string;
}

const localConfig: IEnvironmentConfig = {
  websiteUrl: "https://localhost:3000/",
  baseUrl: "https://localhost:57035/api/",
};

const stageConfig: IEnvironmentConfig = {
  websiteUrl: "https://stg.nexustv.jobvritta.com/",
  baseUrl: "https://api-stg.nexustv.jobvritta.com/api/",
};

const productionConfig: IEnvironmentConfig = {
  websiteUrl: "https://admin.thenexustv.com/",
  baseUrl: "https://api.nexustv.jobvritta.com/api/",
};

let config: IEnvironmentConfig;
const hostname = window.location.hostname;

if (hostname.includes("localhost")) {
  config = localConfig;
} else if (hostname.includes("stg.nexustv")) {
  config = stageConfig;
} else {
  config = productionConfig;
}

export const websiteUrl = config.websiteUrl;
export const baseUrl = config.baseUrl;
export interface ILazyParams {
  first: number;
  rows: number;
  page: number;
  sortField: string;
  sortOrder: DataTableSortOrderType;
}

export const Fetch = async (
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE",
  body: any,
  query: string | null,
  toast: any
) => {
  let params: RequestInit = {
    method: method,
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("auth") + "")?.token
      }`,
    },
  };

  if (body) {
    if (body instanceof FormData) {
      params.body = body;
    } else {
      params.headers = {
        ...params.headers,
        "Content-Type": "application/json",
      };
      params.body = JSON.stringify(body);
    }
  }

  const queryString = query ? `?${query}` : "";

  try {
    const response = await fetch(`${baseUrl}${url}${queryString}`, params);

    if (response.status === 401) {
      sessionStorage.clear();
      toast?.current?.show({
        severity: "error",
        detail: "Unauthorized. Please Login!",
        life: 3000,
      });
      window.location.href = "/login";
      return;
    }

    if (response.status === 400) {
      let errorMessage = "Bad request";
      const text = await response.text();
      try {
        const json = JSON.parse(text);
        if (json?.message) {
          errorMessage = json.message;
        } else if (json?.title) {
          errorMessage = json.title;
        } else if (json?.error) {
          errorMessage = json.error;
        } else if (json?.errors) {
          errorMessage = Object.values(json.errors).flat().join(", ");
        }
      } catch {
        errorMessage = text;
      }
      toast?.current?.show({
        severity: "error",
        detail: errorMessage,
        life: 3000,
      });
      return;
    }
    if (!response.ok) {
      toast?.current?.show({
        severity: "error",
        detail: "Something went wrong!",
        life: 3000,
      });
      return;
    }

    return response;
  } catch {
    toast?.current?.show({
      severity: "error",
      detail:
        "There has been some network trouble or server is not responding.",
      life: 3000,
    });
  }
};
